import React, { useEffect, useRef } from "react";
import cn from "classnames";
import { Script, ScriptStrategy } from "gatsby";

import { useCountry } from "@func-core/core/application/hooks/useCountry";
import { Events } from "@utils/analytics";

import TrackableLink from "@atoms/trackable-link/TrackableLink";

import * as styles from "@organisms/trustpilot-reviews/TrustPilotReviews.module.scss";

declare global {
  interface Window {
    Trustpilot: {
      loadFromElement: (element: HTMLElement | null, inlineScript?: boolean) => void;
    };
  }
}

interface TrustPilotReviewsProps {
  reviewsLink: string;
  adoptionClassName?: string;
}

const TrustPilotReviews = ({
  reviewsLink,
  adoptionClassName,
}: TrustPilotReviewsProps): JSX.Element => {
  const ref = useRef(null);
  const { country } = useCountry();

  useEffect(() => {
    if (window && window.Trustpilot && typeof window.Trustpilot.loadFromElement === "function") {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <>
      <div
        data-testid="trustpilot-reviews"
        className={cn(styles.trustPilotReviews, adoptionClassName)}
      >
        <TrackableLink
          to={reviewsLink}
          eventName={Events.CLICKED_CTA}
          isExternalLink
          openInNewWindow
          adoptionClassName={cn(styles.link)}
          eventSender={"Hero Trustpilot CTA"}
        ></TrackableLink>
        <div
          ref={ref}
          data-testid="trustpilot-widget"
          className={cn(styles.trustPilotWidget, "trustpilot-widget")}
          data-locale={`${country.language.code.toLocaleLowerCase()}`}
          data-template-id="53aa8807dec7e10d38f59f32"
          data-businessunit-id="61483e80f36082001da9dbe4"
          data-theme="light"
          data-style-height="95px"
          data-style-width="165px"
        ></div>
      </div>
      <Script
        strategy={ScriptStrategy.idle}
        src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        async
      />
    </>
  );
};

export default TrustPilotReviews;
